import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import oauthReducer from './auth';
import userReducer from './users';

const appReducer = (history: any) => combineReducers({
    router: connectRouter(history),
	oauth: oauthReducer,
    users: userReducer,
})

const rootReducer = (history: any) => (state:any, action:any) => {
    if (action.type === 'LOGOUT') {
        state = undefined
    }

    return appReducer(history)(state, action);
}

export default rootReducer;
